import React, { useEffect } from "react";
import "./oneWord.css";
import { head, input, remarkStyle, signature } from "../../helper";
import DefaultImage from "../../../../../images/Navbar/2xcell-signature.png";
import { htmlDecode } from "../../../../../utils/parse";
import { QuestionImg } from "../../../../LearningResources/Assement/Image";

export default function OneWord({
  color = "",
  data,
  number,
  correctAnswer,
  setCorrectAnswer,
  onlineTestId,
}) {
  const question = data;
  const id = onlineTestId + "," + question._id;

  useEffect(() => {
    setCorrectAnswer(localStorage.getItem(id));
    if (localStorage.getItem(id)) return;

    const inputs = document.querySelector("#one_word_input");
    inputs.value = "";
  }, [number]);

  const handleChange = (e) => {
    localStorage.setItem(id, e.target.value);
    setCorrectAnswer(e.target.value);
  };

  useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, []);

  return (
    <>
      <div className="container question_card my-4">
        <div className="superhead">
          <div className="remark" style={remarkStyle(color)}>
            Answer in one word
          </div>
          <div className="one__head" style={head(color)}>
            <div className="oneCard">
              <div
                className="oneCard__left"
                dangerouslySetInnerHTML={{
                  __html: htmlDecode(
                    `Q${number}. &nbsp; ${question?.question}`
                  ),
                }}
              ></div>
            </div>
            <div className="oneWord">
              {question?.images?.questionImg ? (
                <QuestionImg image={question?.images?.questionImg} />
              ) : null}
              <input
                placeholder="Write your answer here"
                style={input(color)}
                value={localStorage.getItem(id)}
                id="one_word_input"
                onChange={handleChange}
              />
            </div>

            <div className="last">
              {question.onModel === "admin" ? (
                <img
                  src={DefaultImage}
                  className="signarture"
                  style={{ ...signature(color), width: "120px" }}
                />
              ) : (
                <div className="signarture" style={signature(color)}>
                  {question.creatorId ? question.creatorId.name : ""}
                  <br />
                  {question.schoolId.name}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
